import React from 'react';
import {
  labelFromCatalog,
  RESPUESTA_TIPO_LABELS,
} from '../../../services/copilotoComercialService';

export default function RespuestasSugeridasCopiloto({
  respuestas = [],
  respuestaEnviada = '',
  onRespuestaChange,
  onCopied,
}) {
  const copiar = async (texto) => {
    try {
      await navigator.clipboard.writeText(texto);
      onCopied?.('Respuesta copiada al portapapeles.');
    } catch (_) {
      onCopied?.('No se pudo copiar automaticamente. Selecciona el texto manualmente.');
    }
  };

  if (!respuestas.length) {
    return null;
  }

  return (
    <section className="crm-prospectos-card copiloto-card">
      <div className="crm-prospectos-section-head">
        <div>
          <h2>Respuestas sugeridas</h2>
          <p className="copiloto-help">Revisa la sugerencia antes de enviarla al prospecto.</p>
        </div>
      </div>
      <div className="copiloto-respuestas-grid">
        {respuestas.map((respuesta) => (
          <article key={respuesta.id || respuesta.texto}>
            <strong>{labelFromCatalog(RESPUESTA_TIPO_LABELS, respuesta.tipo)}</strong>
            <p>{respuesta.texto}</p>
            <div className="crm-prospectos-actions">
              <button type="button" onClick={() => copiar(respuesta.texto)}>Copiar</button>
              <button type="button" onClick={() => onRespuestaChange(respuesta.texto)}>Usar como respuesta enviada</button>
            </div>
          </article>
        ))}
      </div>
      <label className="copiloto-respuesta-enviada">
        <span>Respuesta que se envio / se enviara</span>
        <textarea value={respuestaEnviada} onChange={(event) => onRespuestaChange(event.target.value)} rows="4" />
      </label>
    </section>
  );
}
